import { render, staticRenderFns } from "./TranslationMap.vue?vue&type=template&id=3f61deec&scoped=true&"
import script from "./TranslationMap.vue?vue&type=script&lang=js&"
export * from "./TranslationMap.vue?vue&type=script&lang=js&"
import style0 from "./TranslationMap.vue?vue&type=style&index=0&id=3f61deec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f61deec",
  null
  
)

export default component.exports